<template>
  <section class="pb-8" id="contact">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <h1 class="font-weight-normal display-1">Contact Us</h1>
              <h3 class="font-weight-light mt-3">
                Contact Glo Dentistry for all or any of your dental needs.
                Our team is here to assist you – whether you need to schedule an
                appointment, inquire about our services, or discuss insurance
                details, our team is here for you!
              </h3>
              <h3 class="font-weight-light mt-3">
                <i>Trust us for a brighter, healthier smile!</i>
              </h3>
              <h3 class="font-weight-light mt-3">
                Phone: 980-456-3368
              </h3>
              <h3 class="font-weight-light">
                Email: info@glo-dentistry.com
              </h3>
            </v-col>
            <v-col cols="12" sm="7">
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    label="Name"
                    required
                ></v-text-field>

                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                ></v-text-field>

                <v-textarea
                    v-model="textArea"
                    :rules="textAreaRules"
                    label="Message"
                    required
                />

                <v-btn
                    :disabled="!valid"
                    color="primary"
                    :dark="valid"
                    rounded
                    block
                    class="mt-3"
                    @click="submit"
                >
                  Submit
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg"/>
    </div>
    <v-snackbar
        v-model="snackbar.enabled"
        timeout="3000"
        right
        top
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.enabled = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<style scoped>
#contact {
  background-color: #f4f7f5;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

</style>

<script>
import { db } from "@/main";
import firebase from "firebase/app"; // Ensure firebase is imported

export default {
  data: () => ({
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "This field is required.",
      (v) => (v && v.length >= 6) || "The name requires more than 6 characters.",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "This field is required.",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid.",
    ],
    textArea: "",
    textAreaRules: [
      (v) => !!v || "This field is required.",
      (v) => (v && v.length >= 10) || "The message requires more than 10 characters.",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: '',
      color: ''
    }
  }),
  methods: {
    submit() {
      db.collection("contactData").add({
        name: this.name,
        email: this.email,
        message: this.textArea,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      }).then(() => {
        this.snackbar.text = "Message sent successfully";
        this.snackbar.color = "success";
        this.snackbar.enabled = true;
      }).catch((error) => {
        console.error("Error sending message:", error);
        this.snackbar.text = "Error sending message";
        this.snackbar.color = "danger";
        this.snackbar.enabled = true;
      });
    }
  }
};
</script>